/**
 * Run-lifecycle + layout state setters for the Uploads Simulator. Pure
 * `setState` wrappers only — orchestration (polling, timers, persistence)
 * lives on the controller.
 */
class UploadsSimulatorDelegate {
    setActiveTab(activeTab) {
        this.setState({activeTab});
    }

    setFiles(files) {
        this.setState({files});
    }

    /** DragAndDrop emits `{file, name, type, url}` entries — keep the Files. */
    handleFilesChange(entries) {
        this.setState({files: (entries || []).map(entry => entry?.file).filter(Boolean)});
    }

    /** Remounts the DragAndDrop zone (it owns its file list internally). */
    resetFileZone() {
        this.setState({files: [], dndKey: (this.state.dndKey || 0) + 1});
    }

    setRun(run) {
        this.setState({run});
    }

    /** Shallow-merge onto the current run; no-op when no run is active. */
    patchRun(patch) {
        if (!this.state.run) return;
        this.setState({run: {...this.state.run, ...patch}});
    }

    setReport(report) {
        this.setState({report});
    }

    setRunError(runError) {
        this.setState({runError});
    }

    setSelectedFileIndex(selectedFileIndex) {
        this.setState({selectedFileIndex});
    }

    setPanelOpenMobile(panelOpenMobile) {
        this.setState({panelOpenMobile});
    }

    setSamplePresetLoading(samplePresetLoading) {
        this.setState({samplePresetLoading});
    }
}

export default UploadsSimulatorDelegate;
